
import { makeReadonly } from './makeReadonly'
import { newOrder } from './newOrder'
import { setValue } from './setValue'
import { uiSetWith } from './uiSetWith'

import { overwriteWithCopyOfItem } from './overwriteWithCopyOfItem'


const extraActions = {
    readonly: makeReadonly,
    order: newOrder,
    setValue: setValue,
    copyItemTo: overwriteWithCopyOfItem,
    uiSetWith
};

export default extraActions;